import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dimmer, Loader } from 'nallian-shared-ui/lib/components';
import homeTextService from '../services/homeTextService';
import Markdown from '../../app/components/Markdown';

const OverviewText = ({ homeTextFetch, dispatchHomeTextGet, tag, language, name }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (tag && language) {
      dispatchHomeTextGet(tag, language);
    }
  }, [dispatchHomeTextGet, tag, language]);

  return (
    <>
      {homeTextFetch.pending ? (
        <Dimmer active inverted>
          <Loader active inline />
        </Dimmer>
      ) : (
        <>
          {homeTextFetch.value?.contents ? (
            <Markdown markdown={homeTextFetch.value.contents} />
          ) : (
            homeTextFetch.rejected && (
              <>
                <p>{t('dear', { user: name })}</p>
                <p>{t('welcomeToTheCommunity')}</p>
                <p>{t('contactAdministrator')}</p>
              </>
            )
          )}
        </>
      )}
    </>
  );
};

OverviewText.propTypes = {
  homeTextFetch: PropTypes.object.isRequired,
  dispatchHomeTextGet: PropTypes.func.isRequired,
  tag: PropTypes.string,
  language: PropTypes.string,
  name: PropTypes.string,
};

OverviewText.defaultProps = {
  tag: null,
  language: 'en',
  name: '',
};

export default homeTextService(OverviewText);
